module.exports = __webpack_public_path__ + "img/P150T_weapon_84.b26a113b.png";